// ** MUI Imports
import { deepmerge } from "@mui/utils";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import {
  ThemeProvider,
  createTheme,
  responsiveFontSizes,
} from "@mui/material/styles";

import themeConfig from "configs/themeConfig";
import overrides from "./overrides";
import typography from "./typography";
import themeOptions from "./ThemeOptions";
import GlobalStyling from "./globalStyles";

const ThemeComponent = (props) => {
  const { settings, children } = props;
  const coreThemeConfig = themeOptions(settings);
  let theme = createTheme(coreThemeConfig);
  const mergeComponentOverrides = (theme, settings) =>
    deepmerge({ ...overrides(theme, settings) });

  const mergeTypography = (theme) => deepmerge(typography(theme));

  theme = createTheme(theme, {
    components: { ...mergeComponentOverrides(theme, settings) },
    typography: { ...mergeTypography(theme) },
  });

  if (themeConfig.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={() => GlobalStyling(theme, settings)} />
      {children}
    </ThemeProvider>
  );
};

export default ThemeComponent;
